module.exports = __webpack_public_path__ + "img/hgv.5ca13448.jpg";